import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;

let appInsights = null;

if (connectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: false,
      autoTrackPageVisitTime: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      disableFetchTracking: false,
      disableAjaxTracking: false,
      maxBatchInterval: 5000,
      disableExceptionTracking: false,
    }
  });
  appInsights.loadAppInsights();
}

export { appInsights };

export function trackEvent(name, properties = {}) {
  appInsights?.trackEvent({ name }, properties);
}

export function trackPageView(name, uri, properties = {}) {
  appInsights?.trackPageView({ name, uri, properties });
}

export function setAuthenticatedUser(userId, accountId, properties = {}) {
  if (appInsights) {
    appInsights.setAuthenticatedUserContext(userId, accountId, true);
    // Set global properties that appear on every telemetry item
    appInsights.addTelemetryInitializer((envelope) => {
      envelope.data = envelope.data || {};
      Object.assign(envelope.data, properties);
    });
  }
}

export function clearAuthenticatedUser() {
  appInsights?.clearAuthenticatedUserContext();
}
